var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-title", { attrs: { as: "h2", level: "h2" } }, [
        _vm._v(
          "\n        " + _vm._s(_vm.Resources.Faq.FaqPageHeader) + "\n    "
        ),
      ]),
      _vm._v(" "),
      _vm._l(_vm.sections, function (article) {
        return _c(
          "article",
          { key: article.key },
          [
            _c(
              "base-title",
              {
                staticClass: "_mt-3",
                attrs: { as: article.headingTag, level: "h4" },
              },
              [_vm._v("\n            " + _vm._s(article.title) + "\n        ")]
            ),
            _vm._v(" "),
            _c(
              "p",
              [
                article.isCustomComponent
                  ? _c(
                      "localize",
                      { attrs: { resource: article.text } },
                      [
                        _vm._l(article.children, function (child) {
                          return [
                            child.isLink
                              ? _c(
                                  "a",
                                  {
                                    key: child.key,
                                    staticClass: "gfu-link gfu-link--accent",
                                    attrs: {
                                      "format-key": child.formatKey,
                                      href: child.href,
                                      "data-qa": child.dataQa,
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(child.text) +
                                        "\n                    "
                                    ),
                                  ]
                                )
                              : _c(
                                  "span",
                                  {
                                    key: child.key,
                                    attrs: { "format-key": child.formatKey },
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(child.text) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                          ]
                        }),
                      ],
                      2
                    )
                  : [
                      _vm._v(
                        "\n                " +
                          _vm._s(article.text) +
                          "\n            "
                      ),
                    ],
              ],
              2
            ),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }